import React from 'react'
import Home from './Home';

function HomeContainer({isSignedIn, isAdmin}) {    
    return <Home isSignedIn={isSignedIn} isAdmin={isAdmin}/>;
}

export default HomeContainer;
